import { render, staticRenderFns } from "./units-detail-table-panel.vue?vue&type=template&id=21b3ae9e&lang=pug"
import script from "./units-detail-table-panel.vue?vue&type=script&lang=js"
export * from "./units-detail-table-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports